module.exports = __webpack_public_path__ + "3eb1ad62d0896a4af338edf4dd79b7fe.png";